import React, { useState } from "react";
import AppTextField from "../../components/text-field/component";
import AppButton from "../../components/button/component";
import { validateEmail, validatePassword } from "../../utils/validation";
import { toast } from "react-toastify";

const UpdateUserPassword = ({ updateUserPasswordConnect }) => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false); // ✅ Loading state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" })); // clear error on input change
  };

  const handleSubmit = async () => {
    const emailError = validateEmail(formData.email);
    const passwordError = validatePassword(formData.password);

    if (emailError || passwordError) {
      setErrors({ email: emailError, password: passwordError });
      return;
    }

    try {
      setIsLoading(true); // ✅ Start loading
      const res = await updateUserPasswordConnect({
        email: formData.email,
        password: formData.password,
      });

      if (res) {
        toast.success("Password updated successfully!");
        setFormData({ email: "", password: "" }); // Optional: clear form
      } else {
        toast.error("Failed to update password");
      }
    } catch (error) {
      console.error("Error updating password:", error);
      toast.error("Failed to update password");
    } finally {
      setIsLoading(false); // ✅ Stop loading
    }
  };

  return (
    <div className="flex justify-center items-center w-full">
      <div className="m-10 w-full max-w-sm flex flex-col gap-5">
        <h5 className="text-2xl font-semibold text-center">
          Update User Password
        </h5>

        <div>
          <AppTextField
            name="email"
            type="email"
            placeholder="User Email"
            value={formData.email}
            onChange={handleChange}
            disabled={isLoading} // ✅ Disable while loading
          />
          {errors.email && (
            <p className="text-red-600 text-sm mt-1">{errors.email}</p>
          )}
        </div>

        <div>
          <AppTextField
            name="password"
            type="password"
            placeholder="New Password"
            value={formData.password}
            onChange={handleChange}
            disabled={isLoading} // ✅ Disable while loading
          />
          {errors.password && (
            <p className="text-red-600 text-sm mt-1">{errors.password}</p>
          )}
        </div>

        <AppButton
          onClick={handleSubmit}
          disabled={isLoading} // ✅ Disable while loading
          className={`bg-[#FE6634] text-white hover:bg-orange-700 focus:ring-2 focus:ring-orange-500 rounded-full ${
            isLoading ? "opacity-60 cursor-not-allowed" : ""
          }`}
        >
          {isLoading ? "Updating..." : "Update Password"}
        </AppButton>
      </div>
    </div>
  );
};

export default UpdateUserPassword;
